module.exports = {"371522001":"燕塔街道","371522002":"莘亭街道","371522003":"莘州街道","371522004":"东鲁街道","371522101":"张鲁镇","371522102":"朝城镇","371522103":"观城镇","371522104":"古城镇","371522105":"大张家镇","371522106":"古云镇","371522107":"十八里铺镇","371522109":"燕店镇","371522110":"董杜庄镇","371522111":"王奉镇","371522112":"樱桃园镇","371522113":"河店镇","371522114":"妹冢镇","371522115":"魏庄镇","371522116":"张寨镇","371522117":"大王寨镇","371522118":"徐庄镇","371522119":"王庄集镇","371522120":"柿子园镇","371522121":"俎店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371522.json
// module id = 1487
// module chunks = 0